@if (error) {
  <div class="app-error">
    <mat-card appearance="outlined">
      @if (error.status && error.status >= 500) {
        <mat-card-header>Something went wrong</mat-card-header>
        <mat-card-content>Please refresh the page and try again.</mat-card-content>
      } @else {
        @switch (error.code) {
          @case (CODES.TOO_MANY_REQUESTS) {
            <mat-card-header>Too many requests</mat-card-header>
            <mat-card-content>We're receiving too many requests at the moment. Please try again in a few minutes.</mat-card-content>
          }
          @case (CODES.NO_INTERNET) {
            <mat-card-header>No internet</mat-card-header>
            <mat-card-content>
              You're not connected to the internet at the moment, so any changes you make won't be saved. Please check your connection and
              try again.</mat-card-content
            >
          }
          @case (CODES.DEPRECATED) {
            <mat-card-header>New version available</mat-card-header>
            <mat-card-content>
              Please refresh your browser or clear your cache to ensure you are using the latest version of the Land App.</mat-card-content
            >
          }
          @default {
            <mat-card-header>Error</mat-card-header>
            <mat-card-content>{{ error.message }}</mat-card-content>
          }
        }
      }
    </mat-card>
  </div>
}
